import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import { authRequest } from './api'
import { InputField, SubmitButton } from './Form'

function AdminUser() {
  let { id } = useParams()
  let history = useHistory()
  const isNew = id === 'new'
  const [info, setInfo] = useState({ receiveEmails: true })
  const [showPassword, setShowPassword] = useState(isNew ? true : false)
  const [passwordType, setPasswordType] = useState('password')

  function onSubmit(values) {
    const { password, _id, ...rest } = values
    authRequest(`/admin/adminuser`, {
      method: 'POST',
      body: JSON.stringify({
        id: isNew ? null : id,
        ...(showPassword ? { password } : {}),
        ...rest,
      }),
    }).then((info) => {
      setShowPassword(false)
      if (isNew) {
        history.replace(`/adminuser/${info}`)
      } else {
        setInfo({ ...info, password: '' })
      }
    })
  }

  useEffect(() => {
    async function fetchInfo() {
      return await authRequest(`/admin/adminuser?id=${id}`)
        .then((item) => {
          if (item) {
            setInfo(item)
          }
        })
        .catch((err) => {
          console.log({ err })
        })
    }
    if (id && id !== 'new') {
      fetchInfo()
    }
  }, [id])

  return (
    <section className="wrapper">
      <div className="topbar" style={{ width: '30vw' }}>
        <h1 style={{ textTransform: 'capitalize' }}>
          {isNew ? 'New ' : ''}Administrator
        </h1>
      </div>
      <div className="json-form" style={{ width: '30vw' }}>
        <Formik
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          initialValues={info}
          validateOnBlur
          validateOnChange
          enableReinitialize
        >
          {({ handleSubmit, dirty, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <InputField name="username" placeholder="Username" />
              <InputField name="name" placeholder="Name" />
              <InputField name="email" placeholder="Email" type="email" />
              <label>
                <Field type="checkbox" name="receiveEmails" /> Receive Emails?
              </label>
              <br />
              {!isNew && (
                <>
                  <button
                    className="btn btn-info btn-xs"
                    style={{ marginBottom: '1em' }}
                    type="button"
                    onClick={() => {
                      setShowPassword((show) => !show)
                      setFieldValue('password', '', true)
                    }}
                  >
                    Update Password
                  </button>
                  <br />
                </>
              )}
              {showPassword && (
                <>
                  <InputField
                    name="password"
                    type={passwordType}
                    placeholder="Password"
                    validate={validatePassword}
                    autoComplete={false}
                  >
                    <button
                      className="btn btn-info btn-xs"
                      style={{
                        marginBottom: '1em',
                        position: 'absolute',
                        right: '.5em',
                        top: '0.8em',
                      }}
                      type="button"
                      onClick={() => {
                        setPasswordType((type) =>
                          type === 'password' ? 'text' : 'password'
                        )
                      }}
                    >
                      {passwordType === 'password' ? 'Show' : 'Hide'}
                    </button>
                  </InputField>
                </>
              )}
              <SubmitButton disabled={!dirty} />
            </form>
          )}
        </Formik>
      </div>
    </section>
  )
}

export default AdminUser

const validationSchema = Yup.object().shape({
  username: Yup.string().required('Username is Required'),
  name: Yup.string().required('Name is Required'),
  email: Yup.string().email().required('Email is Required'),
})

function validatePassword(value) {
  let error
  const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
  if (!re.test(value)) {
    error = 'Password must have at least 6 characters…'
  }
  return error
}
